import React from "react";
import { ShieldCheck } from "lucide-react";

// Soulumo's price promise: no cheap intro that jumps later.
export const PricePromise = ({ color = "rgba(243,236,217,0.72)", accent = "#d7bb7a", className = "" }) => (
  <div className={`flex items-start gap-2.5 rounded-2xl px-4 py-3 text-left ${className}`} style={{ border: `1px solid ${accent}33`, background: `${accent}0d` }} data-testid="price-promise">
    <ShieldCheck size={16} className="mt-0.5 shrink-0" style={{ color: accent }} />
    <p className="text-[0.8rem] leading-relaxed" style={{ color }}>
      <strong className="font-semibold" style={{ color: accent }}>Your price stays the same.</strong>{" "}
      Many apps lure you in with a cheap first offer, then switch you to a higher subscription. With Soulumo, the price you join at is the price you keep, for as long as you stay.
    </p>
  </div>
);
